import { c as _c } from "react/compiler-runtime";
import type { UsePaginationItem } from '@mui/material/usePagination';
import type { Table } from '@tanstack/react-table';
import { cn } from '@/lib/utils';
export function TablePagination(t0) {
  const $ = _c(9);
  const {
    items,
    table,
    rootRef
  } = t0;
  let t1;
  if ($[0] !== items || $[1] !== rootRef?.current || $[2] !== table) {
    let t2;
    if ($[4] !== rootRef?.current || $[5] !== table) {
      t2 = t3 => {
        const {
          page,
          type,
          selected
        } = t3;
        if (type === "previous") {
          return <button type="button" aria-label="Previous page" className={cn("flex items-center min-w-6.5 justify-center rounded dark:text-neutral-300 dark:disabled:text-zinc-700 border border-transparent text-xs tabular-nums tracking-[.03em] disabled:text-zinc-300", "px-0")} disabled={!table.getCanPreviousPage() || table.getPageCount() === 0} onClick={() => {
            table.previousPage();
            requestAnimationFrame(() => rootRef?.current?.scrollTo({
              top: 0
            }));
          }} key={type}><svg className="icon-[lucide--chevron-left] size-4" /></button>;
        }
        if (type === "start-ellipsis") {
          return <button className={cn("group", "flex items-center min-w-6.5 justify-center rounded dark:text-neutral-300 dark:disabled:text-zinc-700 border border-transparent text-xs tabular-nums tracking-[.03em] disabled:text-zinc-300")} aria-label="Start ellipsis" type="button" onClick={() => {
            table.setPageIndex(Math.max(0, table.getState().pagination.pageIndex - 2));
            requestAnimationFrame(() => rootRef?.current?.scrollTo({
              top: 0
            }));
          }} key={`${type}${page}`}><svg className="icon-[lucide--chevrons-left] hidden size-4 group-hover:inline-block" /><svg className="icon-[prime--ellipsis-h] size-4 group-hover:hidden" /></button>;
        }
        if (type === "first" || type === "page" || type === "last") {
          return <button className={cn("flex items-center min-w-6.5 justify-center rounded dark:text-neutral-300 dark:disabled:text-zinc-700 border border-transparent text-xs tabular-nums tracking-[.03em] disabled:text-zinc-300", selected && "border-border font-bold [--sq-r:.5rem] disabled:text-[unset] sq:rounded-(--sq-r)")} type="button" disabled={selected} onClick={() => {
            table.setPageIndex(Number(page) - 1);
            requestAnimationFrame(() => rootRef?.current?.scrollTo({
              top: 0
            }));
          }} key={`${type}${page}`}>{page}</button>;
        }
        if (type === "end-ellipsis") {
          return <button className={cn("group", "flex items-center min-w-6.5 justify-center rounded dark:text-neutral-300 dark:disabled:text-zinc-700 border border-transparent text-xs tabular-nums tracking-[.03em] disabled:text-zinc-300")} type="button" aria-label="End ellipsis" onClick={() => {
            table.setPageIndex(Math.min(table.getState().pagination.pageIndex + 2, table.getPageCount() - 1));
            requestAnimationFrame(() => rootRef?.current?.scrollTo({
              top: 0
            }));
          }} key={`${type}${page}`}><svg className="icon-[lucide--chevrons-right] hidden size-4 group-hover:inline-block" /><svg className="icon-[prime--ellipsis-h] size-4 group-hover:hidden" /></button>;
        }
        if (type === "next") {
          return <button className={cn("flex items-center min-w-6.5 justify-center rounded dark:text-neutral-300 dark:disabled:text-zinc-700 border border-transparent text-xs tabular-nums tracking-[.03em] disabled:text-zinc-300")} type="button" aria-label="Next page" disabled={!table.getCanNextPage()} onClick={() => {
            table.nextPage();
            requestAnimationFrame(() => rootRef?.current?.scrollTo({
              top: 0
            }));
          }} key={type}><svg className="icon-[lucide--chevron-right] size-4" /></button>;
        }
        return null;
      };
      $[4] = rootRef?.current;
      $[5] = table;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = items.map(t2);
    $[0] = items;
    $[1] = rootRef?.current;
    $[2] = table;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <div className="flex">{t1}</div>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}